import { useEffect, useState } from "react";
import axios from 'axios'
import {Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const UploadEsisStudents = () => {
    const navigate = useNavigate();
    const [disableExecute, setDisableExecute] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [executeCanvasUsers, setExecuteCanvasUsers] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [selectedSchoolId, setSelectedSchoolId] = useState(0);
    const [schools, setSchools] = useState([])
    // On file select (from the pop up)
    const onFileChange = (event) => {
      // Update the state
      if(event.target.files.length > 0){
          setSelectedFile(event.target.files[0]);
      }else{
          setSelectedFile(null)
      }
  
    };
  
    // On file upload (click the upload button)
    const onFileUpload = () => {
      if(selectedFile == ""){
          toast.error("Choose a file before you execute");
          return;
      }
      setExecuteCanvasUsers(1);
      setDisableExecute(true);
      // Create an object of formData
      const formData = new FormData();
  
      // Update the formData object
      formData.append("file", selectedFile, selectedFile.name);
  
      // Request made to the backend api
      // Send formData object
      var config = {
        method: "post",
        url: process.env.REACT_APP_API_URL + "File/FileUpload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
  
      api(config).then(function (response) {
        if (response.status === 200) {
          ExecuteCanvasUsers(response.data);
        }
      });
    };
  
    const ExecuteCanvasUsers = (excelName) => {
      setExecuteCanvasUsers(2);
      var config = {
        method: "post",
        url:
          process.env.REACT_APP_API_URL +
          "Esis/ExecueESISStudents/" +
          excelName ,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
  
      api(config)
        .then(function (response) {
          console.log(response)
          if (response.data.statusCode === 200) {
            setDisableExecute(false);
            setExecuteCanvasUsers(3); //Status Changed to Done
            toast.success("Executed");
          } else {
            setExecuteCanvasUsers(4);
            toast.error(response.data.message);
            setDisableExecute(false);
          }
        })
        .catch(function (error) {
          setExecuteCanvasUsers(4); //Status Changed to Done
          if (error.response.status === 401) {
            localStorage.clear();
            navigate("/login");
            window.location.reload();
          }
        });
    };
  
    useEffect(() => {
    }, []);
    return ( <>
    <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Upload Excel - students.csv
                </h3>
                <div className="align-self-center">
                  <Link
                    to={"/Settings"}
                    className="btn btn-sm btn-secondary mr-5 cts-btn-secondary"
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-sm btn-primary cts-btn-primary"
                    onClick={() => onFileUpload()}
                    disabled={disableExecute}
                  >
                    Execute
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h6>
                      File Selected:{" "}
                      {selectedFile === ""
                        ? "No file selected yet"
                        : selectedFile.name}
                    </h6>
                    <input
                      type="file"
                      className="dropzone custom-file-input"
                      onChange={(e) => onFileChange(e)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>
                              <h6>Excel Sheet Name</h6>
                            </th>
                            <th>
                              <h6>Status</h6>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>students.csv</td>
                            <td>
                              {executeCanvasUsers === 0 && (
                                <div className="btn btn-primary btn-sm">
                                  Waiting
                                </div>
                              )}
                              {executeCanvasUsers === 1 && (
                                <div className="btn btn-warning btn-sm">
                                  Uploading
                                </div>
                              )}
                              {executeCanvasUsers === 2 && (
                                <div className="btn btn-warning btn-sm">
                                  In Progress
                                </div>
                              )}
                              {executeCanvasUsers === 3 && (
                                <div className="btn btn-success btn-sm">
                                  Done
                                </div>
                              )}
                              {executeCanvasUsers === 4 && (
                                <div className="btn btn-danger btn-sm">
                                  Failed
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </> );
}
 
export default UploadEsisStudents;